<template>
  <router-view v-if="ready" class="opc-page" :class="{
    'opc-page-mobile': $context.is.mobile,
    'opc-page-desktop': $context.is.desktop,
    'opc-page-tablet': $context.is.tablet,
  }"></router-view> <!-- TODO v-if = init ready -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {COMMON_ACTION_TYPES} from "@/store/modules/common";
import { logger } from '@/utils/log';
import { isEmptyVal } from '@/utils';
import { pageConfig } from '@/common/service/page-config';
import { CouponErrorHandler } from '@/views/config/coupon/helper/error-handler';
import { PartnerErrorHandler } from '@/views/config/partner-refer/helper/error-handler';
import { getFlowRedirectMessage } from '@/common/service/flow/redirect-message';

export default {
  data() {
    return {
      ready: false,
    }
  },
  async mounted(){
    // TODO await call api to init raw plan map
    this.init();
  },
  computed: {
    ...mapGetters(["cartIsReady", "planMapFlat", "currentEditPlan"]),
  },
  methods: {
    ...mapActions({
      basicConfig: COMMON_ACTION_TYPES.basicConfig, // not have permission
      billingConfig: 'getBasicConfig', // have account permission
    }),
    getBasicConfig() {
      return this.basicConfig()
        .finally(() => {
          this.ready = true;
        });
    },
    async init() {
      try {
        await Promise.all([this.getBasicConfig(), this.billingConfig()]);
      } catch (e) {
        logger.error("init app", e);
      }
    },
    showErrorMessage(message) {
      message && this.$message({
        type: 'info',
        duration: 50000,
        message,
        showClose: true,
        iconClass: "zm-icon-info",
        dangerouslyUseHTMLString: true,
        customClass: "opc-global-info-message",
      });
    },
    popUpErrorMessage() {
      const { couponErrorResult, partnerReferralErrorResult, partnerReferral } = pageConfig;

      if (!isEmptyVal(couponErrorResult)) {
        const instance = new CouponErrorHandler(couponErrorResult, this.planMapFlat);
        const message = instance.getErrorMsgWithErrorCode();
        return this.showErrorMessage(message);
      }

      // only not get partner referral meta info will pop up error message
      if (!isEmptyVal(partnerReferralErrorResult) && isEmptyVal(partnerReferral)) {
        const instance = new PartnerErrorHandler(partnerReferralErrorResult);
        const message = instance.getErrorMsgWithErrorCode();
        return this.showErrorMessage(message);
      }

      const redirectMessage = getFlowRedirectMessage({ currentEditPlan: this.currentEditPlan });

      return this.showErrorMessage(redirectMessage);
    },
  },
  watch: {
    cartIsReady: {
      handler(cartIsReady) {
        cartIsReady && this.popUpErrorMessage();
      },
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/responsive.scss';

.opc-global-info-message {
  &.zm-message {
    background: #ffffff;

    .zm-icon-info {
      margin-right: 16px;
      color: #0B5CFF;
      font-size: 16px;
    }
  }
}

// * enhance responsive
.opc-page-desktop {
  min-width: 976px;
  // * due to out-container #content_container responsive style change, add padding-top to cover page bottom body color
  @include media(mobile, tablet){
    padding-top: 50px;
  }
  .shopping-cart {
    @include media(mobile, tablet){
      padding-top: 40px;
    }
  }
}
</style>
